"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertLayoutRenderer = void 0;
exports.AlertLayout = AlertLayout;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = require("@jsonforms/react");
function AlertLayout({ text, uischema }) {
    const options = uischema.options;
    return ((0, jsx_runtime_1.jsx)(antd_1.Alert, { style: { marginBottom: "24px" }, type: options?.type, message: text, showIcon: true }));
}
exports.AlertLayoutRenderer = (0, react_1.withJsonFormsLabelProps)(AlertLayout);
